import { apiClient } from "./client";

export interface PricingPolicy {
  id: number;
  offre: string;
  marge_min: number | null;
  marge_max: number | null;
  derogation: string;
  validation_dfi: string | null;
  simulator_ids: number[];
  order: number;
  created_at: string;
  updated_at: string;
}

export interface PricingPolicyCreate {
  offre: string;
  marge_min?: number | null;
  marge_max?: number | null;
  derogation: string;
  validation_dfi?: string | null;
  simulator_ids?: number[];
  order?: number;
}

export interface PricingPolicyUpdate {
  offre?: string;
  marge_min?: number | null;
  marge_max?: number | null;
  derogation?: string;
  validation_dfi?: string | null;
  simulator_ids?: number[];
  order?: number;
}

export async function listPricingPolicies(): Promise<PricingPolicy[]> {
  const response = await apiClient.get<PricingPolicy[]>("/pricing-policy/");
  return response.data;
}

export async function createPricingPolicy(data: PricingPolicyCreate): Promise<PricingPolicy> {
  const response = await apiClient.post<PricingPolicy>("/pricing-policy/", data);
  return response.data;
}

export async function updatePricingPolicy(id: number, data: PricingPolicyUpdate): Promise<PricingPolicy> {
  const response = await apiClient.patch<PricingPolicy>(`/pricing-policy/${id}`, data);
  return response.data;
}

export async function deletePricingPolicy(id: number): Promise<void> {
  await apiClient.delete(`/pricing-policy/${id}`);
}

export async function reorderPricingPolicies(orderedIds: number[]): Promise<PricingPolicy[]> {
  const response = await apiClient.put<PricingPolicy[]>("/pricing-policy/reorder", {
    ordered_ids: orderedIds,
  });
  return response.data;
}
